<div class="w-full h-full relative">
  <mat-progress-bar
    *ngIf="state.loadingJob; else jobLogs"
    mode="indeterminate"
    class="w-full absolute top-0 left-0 z-index-3"
  >
  </mat-progress-bar>
</div>

<ng-template #jobLogs>
  <y42-job-logs
    *ngIf="state.event_id; else noEventId"
    [eventId]="state.event_id"
    [sideNavTemplate]="{ template: sideNavTmpl, context: null }"
    (closeDialog)="cancel()"
  ></y42-job-logs>
</ng-template>

<ng-template #sideNavTmpl>
  <div class="time-box-info p-[12px]">
    <ng-container
      y42JobInfoHost
      *ngIf="!!state.job"
      [jobIds]="[state.job.request_id]"
      [showLogsButton]="false"
    ></ng-container>
  </div>
</ng-template>

<ng-template #noEventId>
  <div class="empty-table h-full">
    <img height="130" src="assets/images/not-available/no-data.svg" />
    <div class="empty-table-header">Unable to get job information.</div>
  </div>
</ng-template>
